import { Cursors } from './../../constants';
export class EmptyTool {
    constructor(toolService) {
        this.toolService = toolService;
    }
    start() {
    }
    move() {
    }
    end() {
    }
    tryActivate() {
        return false;
    }
    getCursor() {
        return Cursors.arrow;
    }
}
